<div class="modal-container">
  <mat-toolbar class="modal-header">
    <div class="header-content">
      <h1 class="modal-title">
        {{'modals.modal.email-responses.title' | translate}}
      </h1>
      <button mat-icon-button class="close-btn" (click)="closeDialogue()" [matTooltip]="'generic.buttons.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="modal-body">
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="40" color="primary"></mat-spinner>
        <p>{{ 'generic.loading' | translate }}</p>
      </div>
    } @else {
      @if (emailResponseDatatable && emailResponseDatatable.data.length > 0) {
        <div class="table-card">
          <table mat-table [dataSource]="emailResponseDatatable">
            
            <!-- Email Column -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> {{ 'generic.email' | translate }} </th>
              <td mat-cell *matCellDef="let row" class="email-cell"> {{row.email}} </td>
            </ng-container>

            <!-- Date Column -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef> {{ 'generic.date' | translate }} </th>
              <td mat-cell *matCellDef="let row" class="date-cell"> 
                {{(row.timestamp * 1000) | date:'medium'}}
              </td>
            </ng-container>

            <!-- Event Column -->
            <ng-container matColumnDef="event">
              <th mat-header-cell *matHeaderCellDef> {{ 'generic.event' | translate }} </th>
              <td mat-cell *matCellDef="let row">
                <span class="status-chip" [style.background-color]="emailColorByEvent(row)">
                  {{ ("generic.email-status." + (row.event | replaceSpaces) + ".title") | translate }}
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="response-row"></tr>
          </table>
        </div>
      } @else {
        <div class="empty-state">
          <mat-icon>mail_outline</mat-icon>
          <p>{{ "generic.no_results_found" | translate }}</p>
        </div>
      }
    }
  </div>
</div>
